import './card-detail.scss';
import * as Model from '../../models';
import * as I18n from '../../models/i18n';

type ScopeWatcher = () => void;

interface CardDetailOptions {
  urlPath?: string;
}

export class CardDetailController implements ng.IComponentController, CardDetailOptions {

  public supportUrl: string = 'OligoInquiries@thermofisher.com';
  public plateOligoCardText: string = `Custom oligos are also available in multi-well plates.
  Orders of at least 24 oligos can be delivered in 96-well plates and at least 192 oligos in 384-well plates.`;
  public valueOligoCardText: string = 'For simple, non-modified Oligos consider our';
  public supportCardText: string = 'Our Oligo Inquiries team is here should you have questions or require assistance placing your order. Please contact our technical team at';
  public plateOligoLinkText: string = 'Plate Oligos ordering tool';
  public valueOligoLinkText: string = 'Value Oligos';
  public supportLinkText: string = 'OligoInquiries@thermofisher.com';
  public plateOligoUrl: string = '/store/v2/oligos-dna';
  public urlPath?: string ;

  constructor($scope: ng.IScope, $ngRedux: Model.INgRedux ) {
    const unsubscribeRedux: ScopeWatcher = $ngRedux.connect(this.mapStateToThis.bind(this))(this);
    $scope.$on('$destroy', () => {
      unsubscribeRedux();
    });
  }

  private mapStateToThis = (state: Model.RootState): any => {
    const { world } = state;
    const { appState, vocabulary } = world;
    this.plateOligoCardText = vocabulary[I18n.DictionaryKeys.APP_PLATE_OLIGO_CARD_TEXT] || this.plateOligoCardText;
    this.valueOligoCardText = vocabulary[I18n.DictionaryKeys.APP_VALUE_OLIGO_CARD_TEXT] || this.valueOligoCardText;
    this.supportCardText = vocabulary[I18n.DictionaryKeys.APP_SUPPORT_CARD_TEXT] || this.supportCardText;
    this.plateOligoLinkText = vocabulary[I18n.DictionaryKeys.APP_PLATE_OLIGO_CARD_LINK_TEXT] || this.plateOligoLinkText;
    this.valueOligoLinkText = vocabulary[I18n.DictionaryKeys.APP_VALUE_OLIGO_CARD_LINK_TEXT] || this.valueOligoLinkText;
    this.supportUrl = vocabulary[I18n.DictionaryKeys.APP_SUPPORT_EMAIL] || this.supportUrl;
    this.supportLinkText = vocabulary[I18n.DictionaryKeys.APP_SUPPORT_EMAIL] || this.supportLinkText;
    this.plateOligoUrl = this.urlPath || this.plateOligoUrl;
    if (this.supportLinkText.includes('mailto:')) {
      this.supportLinkText = this.supportLinkText.replace('mailto:', '');
    }
    return {
      appState,
      vocabulary,
    };
  }
}
export const CARD_DETAIL_NAME: string = 'cardDetail';

export const CardDetail: ng.IDirectiveFactory = ($timeout: ng.ITimeoutService, $document: ng.IDocumentService, $window: ng.IWindowService) => {
  return {
    template: require('./card-detail.tpl.html'),
    controller: CardDetailController,
    controllerAs: 'cardDetail',
    restrict: 'E',
    bindToController: true,
    transclude: true,
    scope: {
      urlPath: '<',
    },
    link: (ctrl?: ng.IController) => {
      const controller: CardDetailController = ctrl as CardDetailController;
      const { urlPath } = controller;
    },
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/components/card-detail/card-detail.ts